/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ValueDirective } from '../../directive/value.directive';

@Component({
  selector: 'kit-value',
  templateUrl: './value.component.html',
  styleUrls: ['./value.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ValueComponent extends ValueDirective { }
